var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 16.382H14.5c1.933 0 3.5-1.485 3.5-3.316 0-1.832-1.567-3.316-3.5-3.316h-1.75v10.5",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.75,
    y: 5,
    width: 18.5,
    height: 20,
    rx: 3.5,
    stroke: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParking);
export default __webpack_public_path__ + "static/media/parking.f1b01b7b.svg";
export { ForwardRef as ReactComponent };